export const getFirstLine = (s: string) => (s ? s.split('\n')[0] : '');

export function randomString(length: number = 8): string {
  const chars =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  return Array.from(Array(length))
    .map(() => chars[Math.floor(Math.random() * chars.length)])
    .join('');
}
